export default {
  myPracticeInventory: "10",
  fulfillmentCenterInventory: "40",
};
